
/* Cuida de verificar em um array de tipos primitivos (string || number) 
se o valor já existe e retorna o novo array com ou sem o item */
const handleSimpleCheckbox = <T extends string | number>(
    array: T[],
    valor: T
): T[] => {
    const newArray = [...array];
    const index = newArray.indexOf(valor);

    if (index !== -1) newArray.splice(index, 1);
    if (index === -1) newArray.push(valor);

    return newArray;
}

type TObject = Record<string, any>;
const handleUpdateObjectState = <T extends TObject, K extends keyof T>(
    key: K,
    value: T[K],
    setState: React.Dispatch<React.SetStateAction<T>>
): void => {
    setState(prevState => ({
        ...prevState,
        [key]: value
    }));
};

export { handleSimpleCheckbox, handleUpdateObjectState }